import { Stack } from "@mui/material"
import { Chip, Icon, Typography } from "@cakemail-org/ui-components-v2"
import { useTranslation } from "react-i18next"
import { TLandingCollaborations } from "./types"
import "./styles.scss"

export function LandingCollaborations({ chipLabel, logo, testimony, imgSrc, collaboratorName, companyName, jobTitle }: TLandingCollaborations) {
    const { t, i18n } = useTranslation()
    return <Stack className="landingCollaborations" alignItems="center">
        <Stack alignItems="center" gap={8}>
            <Chip color="cloud" label={chipLabel} icon={<Icon name="Checkmark14" color="secondary" />} />
            <img src={logo} />
            <Typography variant="headline">{testimony}</Typography>
            <Stack direction="row" gap={6}>
                <img src={imgSrc} style={{ width: "80px", height: "80px", borderRadius: "16px" }} />
                <Stack justifyContent="center">
                    <Typography variant="body1L" className="semiBold">{collaboratorName}</Typography>
                    <Typography variant="body1L">{jobTitle}</Typography>
                    <Typography variant="body1L">{companyName}</Typography>
                </Stack>
            </Stack>
        </Stack>
    </Stack>
}